var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23438 10.9395C5.47702 10.9395 6.48438 9.93209 6.48438 8.68945C6.48438 7.44681 5.47702 6.43945 4.23438 6.43945C2.99173 6.43945 1.98438 7.44681 1.98438 8.68945C1.98438 9.93209 2.99173 10.9395 4.23438 10.9395Z",
    stroke: "#737791",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2344 5.93945C11.477 5.93945 12.4844 4.93209 12.4844 3.68945C12.4844 2.44681 11.477 1.43945 10.2344 1.43945C8.99173 1.43945 7.98438 2.44681 7.98438 3.68945C7.98438 4.93209 8.99173 5.93945 10.2344 5.93945Z",
    stroke: "#737791",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98438 8.93945C6.98438 7.93945 7.73438 5.93945 10.2344 5.93945C12.7344 5.93945 13.4844 7.93945 13.4844 8.93945M0.984375 13.9395C0.984375 12.9395 1.73438 10.9395 4.23438 10.9395C6.73438 10.9395 7.48438 12.9395 7.48438 13.9395",
    stroke: "#737791",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers1);
export default __webpack_public_path__ + "static/media/users_1.51827ea3c163fe86b569c2cb6157e298.svg";
export { ForwardRef as ReactComponent };